import { Checkbox, FormControlLabel } from '@mui/material';

interface CheckBoxFieldComponentProps {
  onCheckBoxChange: (event: any) => void;
  label: string;
  keyName: string;
  name: string;
  isRequired: boolean;
  errorStr: string;
  items: any[];
  checkField: any[];
}
const CheckBoxFieldComponent: React.FC<CheckBoxFieldComponentProps> = ({
  onCheckBoxChange,
  checkField,
  label,
  items,
  isRequired,
  keyName,
  name,
  errorStr,
}) => {
  return (
    <div className="row" key={keyName}>
      <div className="col">
        {items.length > 0 && (
          <label className="form-label">
            {label} {isRequired && <small style={{ color: 'red' }}> *</small>}
          </label>
        )}
        <div className="form-check">
          {items.map((item: any, index: any) => (
            <div className="roleEle" key={'roleele_' + index}>
              <FormControlLabel
                checked={
                  checkField.indexOf(item.id.toString()) !== -1 ? true : false
                }
                style={checkStyle}
                id={item.id + '_lbb' + index}
                key={item.id + '_' + index}
                control={
                  <Checkbox
                    key={'chk_' + keyName + '_' + index}
                    name={name}
                    onChange={onCheckBoxChange}
                    checked={checkField.includes(item.id.toString())}
                    value={item.id.toString()}
                    style={checkStyle}
                  />
                }
                label={item.label}
              />
            </div>
          ))}
        </div>
        {errorStr && <span className="bad-field">{errorStr}</span>}
      </div>
    </div>
  );
};
export default CheckBoxFieldComponent;

const checkStyle = {
  fontSize: '13px',
};
